import type { GetResearchConfigurationsLiteParams } from '@types';

export const userConfigurationsQueryKey = (userId?: string) =>
  ['user-configurations', userId] as const;

export const configurationQueryKey = (configurationId?: string) =>
  ['configuration', configurationId] as const;

export const researchConfigurationsLiteQueryKey = (
  userId?: string,
  params?: GetResearchConfigurationsLiteParams
) =>
  [
    'research-configurations-lite',
    userId,
    params?.status,
    params?.page,
    params?.size,
    params?.searchId,
    params?.searchPatient,
    params?.searchDate,
  ] as const;
